import styles from './AnimatedBackground.module.scss'

const AnimatedBackground = () => {
    return (
        <ul className={styles.animated_bg}>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
        </ul>
    )
}

export default AnimatedBackground